var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cd-section",attrs:{"id":"projects"}},[_c('Project1'),_c('Project2'),_c('Project3')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }